import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "document-details-dialog remove-padding",
    contentStyle: _ctx.mainDescriptor.style.flex,
    position: "right",
    visible: _ctx.visible,
    modal: false,
    closable: false,
    baseZIndex: 10,
    autoZIndex: true
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary kn-width-full" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.info.datasetDialogTitle')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "p-button-text kn-button",
        label: _ctx.$t('common.cancel'),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('closeDialog')))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        label: _ctx.$t('common.save'),
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('saveSelectedDataset', _ctx.selectedDataset), _ctx.$emit('closeDialog')))
      }, null, 8, ["label"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_DataTable, {
        class: "p-datatable-sm kn-table p-m-2",
        value: _ctx.datasets,
        dataKey: "id",
        responsiveLayout: "stack",
        filters: _ctx.filters,
        "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters = $event)),
        globalFilterFields: _ctx.infoDescriptor.globalFilterFields,
        loading: _ctx.loading,
        selection: _ctx.selectedDataset,
        "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedDataset = $event)),
        selectionMode: "single",
        stripedRows: ""
      }, {
        header: _withCtx(() => [
          _createVNode("span", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_InputText, {
              class: "kn-material-input",
              modelValue: _ctx.filters['global'].value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
              type: "text",
              placeholder: _ctx.$t('common.search'),
              "data-test": "filterInput"
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "label",
            header: _ctx.$t('common.label'),
            sortable: true
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "name",
            header: _ctx.$t('common.name'),
            sortable: true
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "description",
            header: _ctx.$t('common.description'),
            sortable: true
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "owner",
            header: _ctx.$t('common.owner'),
            sortable: true
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "scope",
            header: _ctx.$t('managers.datasetManagement.scope'),
            sortable: true
          }, null, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value", "filters", "globalFilterFields", "loading", "selection"])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
}